/**
 * <TutorQuizFirstMention> — « Quiz d'abord · Retirer » sous la ligne d'une activité (molecule).
 *
 * L'ancienne mention de la fiche du tuteur (`QuizFirstMention.js`) : l'élève passe par le quiz de
 * prérequis avant l'énoncé, et le tuteur peut le retirer. La même au centre du live
 * (`<TutorLiveCenter>`) et dans la fiche (`<TutorActivityDetailsModal>`) : la chip du livre, et
 * « Retirer » qui tourne pendant le retrait.
 */
import React from "react"

import { Badge } from "../../atoms/Badge"
import { TextButton } from "../../atoms/Buttons/TextButton"
import { Row } from "../../atoms/containers/Row"

export type TutorQuizFirstMentionProps = {
    onRemove: () => void
    /** Le retrait part. Défaut `false`. */
    removing?: boolean
    testID?: string
}

const TEXTS = { quizFirst: "Quiz d'abord", remove: "Retirer", removeLabel: "Retirer le quiz" }

export function TutorQuizFirstMention(props: TutorQuizFirstMentionProps) {
    const { onRemove, removing = false, testID } = props
    return (
        <Row gap="1" align="center" testID={testID}>
            <Badge text={TEXTS.quizFirst} variant="info" tinted iconName="tasks" truncate={false} />
            <TextButton
                label={TEXTS.remove}
                size="sm"
                loading={removing}
                onPress={onRemove}
                accessibilityLabel={TEXTS.removeLabel}
            />
        </Row>
    )
}
